import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import SectionTitle from '@src/components/SectionTitle';
import CheckSvg from '@src/svgs/fr-check.svg';
import Checkbox from '@src/components/Checkbox';
import { PackagePreview } from '../PackagePreview';
import { BrandingPackageOptions, SelectBrandingPackageProps } from './props';
import './styles.scss';

export const SelectBrandingPackage: FC<SelectBrandingPackageProps> = ({
  priceInEur,
  selectedPackage,
  onSelectPackage,
}) => {
  return (
    <div className="select-branding-package">
      <div
        className={classnames(
          'select-branding-package__item',
          selectedPackage === BrandingPackageOptions.BASIC && 'select-branding-package__item--selected',
        )}
        onClick={() => {
          onSelectPackage(BrandingPackageOptions.BASIC);
        }}
      >
        <SectionTitle size="M" title="Basic" subtitle="Post your job for free." />
        <Checkbox
          style="highlighted"
          value={selectedPackage === BrandingPackageOptions.BASIC}
          disableStateChange
          propagateEvent
        />

        <div className="select-branding-package__item-features">
          <div className="select-branding-package__item-feature">
            <Svg className="select-branding-package__item-feature-icon" src={CheckSvg} />
            <span>Your job appears in search.</span>
          </div>
          <div className="select-branding-package__item-feature">
            <Svg className="select-branding-package__item-feature-icon" src={CheckSvg} />
            <span>Simple branding without extended details and images.</span>
          </div>
        </div>
        <div className="select-branding-package__item-price">
          <span>Price:</span>
          <span>€0</span>
          <span>/mo</span>
        </div>
        <div className="select-branding-package__item-preview">
          <p>Here&apos;s how your listing will look like:</p>
          <PackagePreview />
        </div>
      </div>

      <div
        className={classnames(
          'select-branding-package__item',
          selectedPackage === BrandingPackageOptions.PREMIUM && 'select-branding-package__item--selected',
        )}
        onClick={() => {
          onSelectPackage(BrandingPackageOptions.PREMIUM);
        }}
      >
        <div className="select-branding-package__item-premium-strip" />
        <SectionTitle size="M" title="Employer Branding" subtitle="Make your job stand out among competition." />
        <Checkbox
          style="highlighted"
          value={selectedPackage === BrandingPackageOptions.PREMIUM}
          disableStateChange
          propagateEvent
        />

        <div className="select-branding-package__item-features">
          <div className="select-branding-package__item-feature">
            <Svg className="select-branding-package__item-feature-icon" src={CheckSvg} />
            <span>Employer branding with a premium look and more visuals.</span>
          </div>
          <div className="select-branding-package__item-feature">
            <Svg className="select-branding-package__item-feature-icon" src={CheckSvg} />
            <span>Frank AI takes case of promoting your job offer and summarising the key details.</span>
          </div>
        </div>
        <div className="select-branding-package__item-price">
          <span>Price:</span>
          <span>€{priceInEur}</span>
          <span>/mo</span>
        </div>
        <div className="select-branding-package__item-preview">
          <p>Here&apos;s how your listing will look like:</p>
          <PackagePreview isPremium />
        </div>
      </div>
    </div>
  );
};
